module.exports = __webpack_public_path__ + "img/乐享官网banner3.f66acd77.jpg";